__turbopack_context__.v({
  "item": "NewsList-module-scss-module__0Tmvxq__item",
  "itemImage": "NewsList-module-scss-module__0Tmvxq__itemImage",
  "itemText": "NewsList-module-scss-module__0Tmvxq__itemText",
  "itemTitle": "NewsList-module-scss-module__0Tmvxq__itemTitle",
  "itemsContainer": "NewsList-module-scss-module__0Tmvxq__itemsContainer",
  "title": "NewsList-module-scss-module__0Tmvxq__title",
  "wrapper": "NewsList-module-scss-module__0Tmvxq__wrapper",
});
